var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flix-form-group"},[_vm._v(" "+_vm._s(_vm.$t('constants.months')[_vm.date.getMonth() + 1])+" "+_vm._s(_vm.date.getFullYear())+" "),_c('div',{staticClass:"flix-html-h1"},[_vm._v(_vm._s(_vm.$getNullsBefore(_vm.date.getDate())))]),_vm._v(" "+_vm._s(_vm.$t('constants.weekdays')[_vm.$getWeekday(_vm.date)])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }